// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__26lh8","header":"PatientQuestionnaire_header__1KHPH","info":"PatientQuestionnaire_info__1KVkc"};